import { ThemeProvider } from '@mui/material/styles'

import { useSharedContext } from './shared'

import { themeKizzo } from 'app/themeKizzo'
import { theme } from 'app/theme'

export default function CustomThemeProvider({ children }: { children: React.ReactNode }) {
    const { isKizzoBranded } = useSharedContext()

    return <ThemeProvider theme={isKizzoBranded ? themeKizzo : theme}>{children}</ThemeProvider>
}
